import { computed, ref, type ComputedRef } from "vue";
import { FEATURE_NAMES, logError } from "@/loggers";
import { getGlobalOptionsProvider, type SelectOption } from "./registry";

export interface UseGlobalOptionsResult {
  options: ComputedRef<SelectOption[]>;
  fetch: () => Promise<void> | void;
}

export const useGlobalOptions = (key: string): UseGlobalOptionsResult => {
  const provider = getGlobalOptionsProvider(key);

  if (!provider) {
    logError(FEATURE_NAMES.MVS_FILTERS, `[useGlobalOptions] no provider registered for key "${key}"`);
    const empty = ref<SelectOption[]>([]);
    return {
      options: computed(() => empty.value),
      fetch: () => {}
    };
  }

  return {
    options: computed(() => provider.options.value),
    fetch: () => provider.fetch()
  };
};
